import { Component, OnInit } from '@angular/core';
import { ColDef, ExcelExportParams, ExcelStyle, GridApi, GridReadyEvent, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { HrmsService } from '../hrms.service';

@Component({
  selector: 'app-dept-desig-details',
  templateUrl: './dept-desig-details.component.html',
  styleUrls: ['./dept-desig-details.component.scss']
})
export class DeptDesigDetailsComponent implements OnInit {
  private gridApi!: GridApi<any>;
  quickFilter: string = '';
  constructor(private spinner: NgxSpinnerService, private Service: HrmsService) { }
  ngOnInit(): void {
    this.hrmsDeptDesign();
  }

  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  defaultExcelExportParams: ExcelExportParams = {
    exportAsExcelTable: true,
  };

  colDefs: ColDef<any>[] = [
    {
      field: 'desigId', headerName: 'Desig Id',
      minWidth: 100,
      maxWidth: 100,
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'desigName', headerName: 'Desig Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'departmentId', headerName: 'Dept Id',
      minWidth: 100,
      maxWidth: 100,
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'departmentName', headerName: 'Dept Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'typeId', headerName: 'Type Id',
      minWidth: 100,
      maxWidth: 100,
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'typeName', headerName: 'Type Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },

  ]

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };

  excelStyles: ExcelStyle[] = [
    {
      id: 'headerCell',
      font: { bold: true, size: 26 },
        alignment: { horizontal: 'Center', vertical: 'Center' },
    }
  ];

  hrmsDeptDesign() {
    this.spinner.show();
    this.Service.getDeptdesign().subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.rowData = res;
        // console.log('res', res);
        this.spinner.hide();

      },
      error: (err: any) => {
        this.spinner.hide();
      }
    });
  }

  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'HRMS_Dept&Design_Details',
      sheetName: 'HRMS Dept&Design Details',

      exportAsExcelTable: false, 

      prependContent: [
        {
          cells: [
            {
              styleId: 'headerCell',
              data: {
                type: 'String',   // ← old versions use plain string
                value: 'HRMS DEPORTMENT AND DESIGNATION DETAILS REPORT'
              },
                mergeAcross: 5
            }
          ]
        },
        {
          cells: []  // blank row
        }
      ]
    };

    this.gridApi.exportDataAsExcel(params);
    alert("Excel Report generated. Please check Downloads.");
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }



}
